import React from 'react';
import moment from 'moment';

const Body = data  => (
    <div>
        <p className="report_generated_date mt-2">Generated on : <ins>{moment().format('MMMM Do YYYY, h:mm:ss a')}</ins></p>
        <div className="table-responsive mt-2">
            <table className="table table_center report_table">
                <thead>
                    <tr>
                        <th className="annual_header">Date</th>
                        <th className="annual_header">Name</th>
                        <th className="annual_header">Start</th>
                        <th className="annual_header">End</th>
                        <th className="annual_header">Break</th>
                        <th className="annual_header">Total H</th>
                    </tr>
                </thead>
                <tbody>
                    {
                          (data.shiftByEmployee || []).map((item,index) => {
                                return(
                                    <tr key={index}>
                                        <td>{item.date}</td>
                                        <td>{item.employeeName}</td>
                                        <td>{item.startShift}</td>
                                        <td>{item.endShift}</td>
                                        <td>{item.paidBreak}</td>
                                        <td>{item.totalHours}</td>
                                    </tr>
                                );
                          })
                      }    
                </tbody>
            </table>
        </div> {/* .table-responsive */}
    </div>
);
export default Body;